import { css } from '@emotion/react';

export default $ => css`
  .form-control.signature {
    position: relative;
    display: block;
    box-sizing: content-box;

    > .button-bar {
      position: absolute;

      > .btn {
        font-size: 0.5rem;

        > i {
          font-size: 0.7rem;
        }
      }

      > label {
        margin-bottom: 0;
      }

      > .gap {
        display: inline-block;
        width: 12px;
      }

      &.tr {
        top: 0;
        right: 0;
      }
    }

    > .signature-pad {
      padding: 0;

      &.writable {
        cursor: crosshair;
      }
    }

    > .no-signature {
      user-select: none;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    input[type='file'] {
      display: none;
    }
  }
`;
